module.exports = __webpack_public_path__ + "static/banner-left-ddd355a49aa40763b048e2e7616123da.jpg";